<div *ngIf="hits.length !== 0" class="hits">
  <div class="hit" *ngFor="let hit of filterHits(hits)">
    <!-- 
      `childComponent` is used to render the passed in component. `context` defines the available variables to be binded
      using the `let-...` syntax. Using the `$implicit` token set the default value to be binded, in this case, the current hit
    -->
    <ng-container
      *ngTemplateOutlet="childComponent; context: { $implicit: hit }"
    ></ng-container>
  </div>
</div>

<div *ngIf="displayNoResultsLabel()" class="no-results-label">
  {{ noResultsMessage }}
</div>

<div *ngIf="hits.length > 0 && !isLastPage" class="ion-text-center">
  <ion-button color="primary" (click)="queryNextPage()">
    <ion-label>See More</ion-label>
  </ion-button>
</div>